import BaseListPresenter from "../../../../base/BaseListPresenter";
import {
  getPipelineHolidays,
  getPipelineSuspension,
} from "../../../../components/common/PipelineQuery";
import { findObjectUseCase } from "../../../../usecases/object";
import AggregateUseCase from "../../../../usecases/object/AggregateUseCase";

class ManagerCounterPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    updateSchemaUseCase,
  ) {
    super(view, findObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
  }

  fields = ["region", "office", "division", "section", "unit", "cluster"];

  async componentDidMount() {
    const currentUser = this.view.getCurrentUser();
    const employeeID = currentUser.employee;
    const empID = employeeID.id;
    const userID = currentUser.id;
    const date = new Date();

    // holiday query
    const listOfEmployee = await findObjectUseCase().execute("employees", {
      // where: { id: empID },
      keys: this.fields,
    });

    const employee = listOfEmployee.filter((employee) => employee.id === empID);

    const emp = employee[0];

    const aggregateUseCase = new AggregateUseCase();
    // const holiday = await aggregateUseCase.execute("holidays", pipeline);
    // const suspension = await aggregateUseCase.execute("suspension", pipeline2);

    // const holidayQuery = HolidayQuery(employee, this.fields);
    const [
      holiday,
      // approvedLeave,
      employeeOnLeave,
      tasks,
      enrolledTraining,
      suspension,
    ] = await Promise.all([
      aggregateUseCase.execute("holidays", getPipelineHolidays(emp)),
      // findObjectUseCase().execute("leave_request", {
      //   where: { stats: "Approved", employee: employeeID },
      // }),
      findObjectUseCase().execute("leave_request", {
        where: {
          stats: "Approved",
          startdate: { $lte: date }, // startdate is less than or equal to the current date
          enddate: { $gte: date }, // enddate is greater than or equal to the current date
        },
      }),
      findObjectUseCase().execute("requests", {
        where: {
          $or: [
            {
              "workFlow.tasks.0.hierarchy.approve.id": userID,
            },
            {
              "workFlow.tasks.0.hierarchy.reject.id": userID,
            },
            {
              "workFlow.tasks.0.hierarchy.request.id": userID,
            },
            { "employee.id": empID },
          ],
        },
      }),

      findObjectUseCase().execute("enroll_training", {
        where: { stats: "Enrolled", empID: empID },
      }),

      aggregateUseCase.execute("suspension", getPipelineSuspension(emp)),
    ]);

    const approvedLeave = employeeOnLeave.filter(
      (emp) => emp.employee.id === employeeID.id,
    );

    const activeEmployee = listOfEmployee.filter(
      (employee) =>
        !employeeOnLeave.some((leave) => leave.employee.id === employee.id),
    );

    this.view.setState({
      holiday,
      approvedLeave,
      employeeOnLeave: employeeOnLeave.length,
      tasks: tasks.length,
      enrolledTraining,
      suspension,
      activeEmployee,
    });
  }

  async onSubmitAddWidget(obj) {
    try {
      this.view.submitting();
      const object = await this.upsertUseCase.execute("dashboard", obj);
      this.objects.push(object);
      this.view.setObjects(this.objects);
      this.view.submissionSuccess();
    } catch (error) {
      this.view.showError(error);
    }
  }

  async onSubmitDelete(index) {
    try {
      this.view.submitting();
      const object = this.objects[index];
      await this.deleteObjectUseCase.execute("dashboard", object.id);
      this.objects.splice(index, 1);
      this.view.setObjects(this.objects);
      this.view.submissionSuccess();
    } catch (error) {
      this.view.showError(error);
    }
  }
  onSubmitEditCollection(schema) {
    this.view.closeDialog();
    this.updateSchemaUseCase
      .execute(schema)
      .then((schema) => {
        const schemas = this.view.getSchemas();
        const index = schemas.findIndex(
          (s) => s.collection === schema.collection,
        );
        schemas[index] = schema;
        this.view.setSchemas(schemas);
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }
}

export default ManagerCounterPresenter;
